import { marginCriteriaApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { extractErrorMessage } from '../marginCenter.actionUtils';

export const CRITERIA_ACTION_TYPE = createNamedActions('marginCenter/criteria', {
  GET_MARGIN_CRITERIA: 'GET_MARGIN_CRITERIA',
  SET_CRITERIA_LOADING: 'SET_CRITERIA_LOADING',
  SET_CRITERIA_ERROR: 'SET_CRITERIA_ERROR',
  UPSERT_CRITERIA: 'UPSERT_CRITERIA',
  REMOVE_CRITERIA: 'REMOVE_CRITERIA',
  SET_CRITERIA_SAVING: 'SET_CRITERIA_SAVING',
  SET_CRITERIA_SAVE_ERROR: 'SET_CRITERIA_SAVE_ERROR',
  CLEAR_CRITERIA_SAVE_ERROR: 'CLEAR_CRITERIA_SAVE_ERROR',
});

export const getMarginCriteriaAction =
  (params = {}) =>
  async dispatch => {
    dispatch({ type: CRITERIA_ACTION_TYPE.SET_CRITERIA_LOADING, payload: true });

    try {
      const { data } = await marginCriteriaApi.getCriteria(params);

      return dispatch({ type: CRITERIA_ACTION_TYPE.GET_MARGIN_CRITERIA, payload: data });
    } catch {
      return dispatch({ type: CRITERIA_ACTION_TYPE.SET_CRITERIA_ERROR });
    }
  };

// Create when no criteriaId, else update. Returns the saved criteria on success, null on failure. A
// tier-3 fair-lending rejection lands here as a 400/409 whose message is reduced into save.errorMessage
// and surfaced inline (the schema rejection is the designed UX — never pre-hidden).
export const saveMarginCriteriaAction =
  ({ criteriaId, request }) =>
  async dispatch => {
    dispatch({ type: CRITERIA_ACTION_TYPE.SET_CRITERIA_SAVING, payload: true });

    try {
      const { data } = criteriaId
        ? await marginCriteriaApi.editCriteria(criteriaId, request)
        : await marginCriteriaApi.createCriteria(request);

      dispatch({ type: CRITERIA_ACTION_TYPE.UPSERT_CRITERIA, payload: { criteriaId, data } });

      return data;
    } catch (error) {
      dispatch({
        type: CRITERIA_ACTION_TYPE.SET_CRITERIA_SAVE_ERROR,
        payload: extractErrorMessage(error),
      });

      return null;
    }
  };

// Returns true on success, null on failure. A failed DELETE reduces the server message into the same
// inline mutation-error slice and the row is retained — never an unhandled rejection with no feedback.
export const deleteMarginCriteriaAction = criteriaId => async dispatch => {
  try {
    await marginCriteriaApi.deleteCriteria(criteriaId);
  } catch (error) {
    dispatch({
      type: CRITERIA_ACTION_TYPE.SET_CRITERIA_SAVE_ERROR,
      payload: extractErrorMessage(error),
    });

    return null;
  }

  dispatch({ type: CRITERIA_ACTION_TYPE.REMOVE_CRITERIA, payload: criteriaId });

  return true;
};

export const clearCriteriaSaveErrorAction = () => dispatch =>
  dispatch({ type: CRITERIA_ACTION_TYPE.CLEAR_CRITERIA_SAVE_ERROR });
